import * as React from 'react';

interface AccessClosedProps {
  message: string;
}

class AccessClosed extends React.Component<AccessClosedProps> {
  render() {
    return (
      <div className="section section--login-form">
        <p>{this.props.message}</p>
      </div>
    );
  }
}

export default AccessClosed;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AccessClosed.tsx